/* eslint-disable @typescript-eslint/no-explicit-any */
import { isObject } from './isObject'

type EmptyObject = {
  [K in any]: never
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isEmptyObject(val: any): val is EmptyObject {
  return isObject(val) && Object.keys(val).length === 0
}
